import { createMutationHelper } from '@utils/swr'
import { type ResetPasswordRequest } from '../../../types/apiRequest'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['put']['resetPassword'], never, ResetPasswordRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/password',
  fetcher: (url, { arg, client }) => {
    return client.put(url, arg)
  },
})

export const useRequestRestPassword = useMutation
